import type { IBannerImage } from "InterfacesTypes/interfaces";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectBannerImage } from "state/selectors/Selectors";
import { getEnvironment } from "utils/utils";

const BannerImageCarousel = () => {
  const [active, setActive] = useState(0);
  const env = getEnvironment();
  const bannerImage: IBannerImage[] = useSelector(selectBannerImage);

  // Automatically cycle every 4 seconds (optional)
  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % bannerImage.length);
    }, 8000);
    return () => clearInterval(timer);
  }, [bannerImage.length]);

  return (
    <div className="relative w-full h-[280px] overflow-hidden">
      <div
        className={`absolute inset-0 transition-opacity duration-1000 ease-in-out 
            index === active ? "opacity-100 z-10" : "opacity-0 z-0"  ${
              0 === active ? "opacity-100 z-10" : "opacity-0 z-0"
            }
          `}
      >
        <img
          src={`${env.imageUrl}${bannerImage[0]?.ImageUrl}`}
          alt="FMV"
          className="!object-cover !max-w-[100%] !w-full !h-[290px] "
        />
        <div className="absolute bottom-[42px] inset-0 flex items-end justify-center">
          <p className="!text-white text-3xl font-bold cover-img-texts hover:scale-105 transition-transform duration-600 text-center">
            {bannerImage[0]?.Title}
          </p>
        </div>
      </div>
      <div
        className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
          1 === active ? "opacity-100 z-10" : "opacity-0 z-0"
        }
           
          `}
      >
        <img
          src={`${env.imageUrl}${bannerImage[0]?.ImageUrl}`}
          alt="FMV"
          className="!object-cover !max-w-[100%] !w-full !h-[290px] "
        />
        <div className="absolute bottom-[42px] left-[60px] right-[60px] inset-0 flex items-end justify-center ">
          <p className="!text-white text-base text-center cover-img-texts hover:scale-105 transition-transform duration-600">
            {bannerImage[1]?.Title}
          </p>
        </div>
      </div>
    </div>
  );
};
export default BannerImageCarousel;
